﻿import React, { useState } from "react";
import GoogleButton from "./GoogleButton.jsx";
import { verifyLogin } from "../utils/accounts.js";

export default function LoginModal({ onLogin, onClose }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setError("");
    setBusy(true);
    try {
      await onLogin(await verifyLogin({ email, password }));
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <div className="modal-backdrop" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <form className="modal-card" onSubmit={submit}>
        <h3>Login</h3>
        {error && <div className="alert alert-danger py-2">{error}</div>}
        <GoogleButton onSuccess={onLogin} onError={setError} />
        <div className="form-group">
          <label htmlFor="li-email">Email</label>
          <input id="li-email" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="form-group">
          <label htmlFor="li-pw">Password</label>
          <input id="li-pw" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <div className="modal-actions">
          <button type="button" className="btn btn-outline-secondary" onClick={onClose}>Cancel</button>
          <button type="submit" className="btn btn-purple" disabled={busy}>{busy ? "Signing in..." : "Login"}</button>
        </div>
      </form>
    </div>
  );
}
